import { usePaymentSettings } from '@/hooks/usePaymentSettings';
import { usePaymentLinksEnabled } from '@/providers/FeatureFlagProvider';

/**
 * Whether payment links can be offered to the user: the feature has to be released to the tenant and
 * PaySuite onboarding has to have produced a merchant, which the API reports. It fails closed while
 * the settings are loading or unreadable, so a payment link variable is never offered for an
 * organisation the API would refuse it for.
 *
 * The payment settings endpoint is admin-only, so only admin surfaces (settings) may call this.
 */
export function usePaymentLinksAvailable(): { isAvailable: boolean; isLoading: boolean } {
  const isFeatureEnabled = usePaymentLinksEnabled();
  const { data: settings, isLoading } = usePaymentSettings({ enabled: isFeatureEnabled, forceLive: true });

  return {
    isAvailable: isFeatureEnabled && settings?.paymentLinksAvailable === true,
    isLoading: isFeatureEnabled && isLoading,
  };
}
